import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=163a7896&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('163a7896')) {
      api.createRecord('163a7896', component.options)
    } else {
      api.reload('163a7896', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=163a7896&", function () {
      api.rerender('163a7896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21KmikSc8NCRT/JS/comp/openstreetmap.vue"
export default component.exports